import useTranslation from 'next-translate/useTranslation';
import React, { useState } from 'react';

import HeaderMasthead from '../HeaderMasthead/HeaderMasthead';
import HeaderNav from '../HeaderNav/HeaderNav';
import { LogoLink, StyledLogo, Wrapper } from './Header.styles';

const Header = ({ languageSwitch, navigation, headerData, isScrolled }) => {
  const [navIsOpen, setNavIsOpen] = useState(false);
  const { lang } = useTranslation();
  const homepageUrl = lang === 'nl' ? '/nl' : '/';

  return (
    <>
      <Wrapper navIsOpen={navIsOpen} isScrolled={isScrolled}>
        <LogoLink href={homepageUrl} as="a">
          <StyledLogo />
        </LogoLink>
        {languageSwitch && (
          <HeaderNav
            languageSwitch={languageSwitch}
            navigation={navigation}
            navIsOpen={navIsOpen}
            setNavIsOpen={setNavIsOpen}
          />
        )}
      </Wrapper>
      {headerData && <HeaderMasthead headerData={headerData} />}
    </>
  );
};

export default Header;
